import { useEffect, useRef, useState } from 'react';
import type { PortfolioData } from '../domain/portfolio.types';

export function Skills({ data }: { data: PortfolioData }) {
  const ref = useRef<HTMLElement>(null);
  const [seen, setSeen] = useState(false);
  
  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setSeen(true); io.disconnect(); }
    }, { threshold: 0.15 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  const totalSkills = data.skills.groups.reduce((n, g) => n + g.items.length, 0);

  return (
    <section className="section" id="skills" ref={ref}>
      <div className="container">
        <div className="reveal" style={{ marginBottom: 40 }}>
          <div className="section-tag">02 · Skills & experience</div>
          <h2 className="section-title">What I actually <span className="alt">ship with</span>.</h2>
          <p className="section-sub">Grouped by where I spend my time. Years are real production years, not "I read the docs once". Levels reflect honest comfort, not ego.</p>
        </div>

        <div className="skills-shell reveal">
          <div className="skills-header">
            <span><span className="id">PROFILE:</span> {data.skills.archetype}</span>
            <span>{data.skills.groups.length} GROUPS · {totalSkills} TOOLS</span>
          </div>

          <div className="skills-groups">
            {data.skills.groups.map((g, gi) => (
              <div className="skill-group" key={gi}>
                <div className="skill-group-title">
                  <span>{String(gi + 1).padStart(2, '0')} · {g.title}</span>
                  <span className="ct">{g.items.length} TOOLS</span>
                </div>
                {g.items.map((s, i) => (
                  <div className="skill-row" key={i}>
                    <span className="ix">{String(i + 1).padStart(2, '0')}</span>
                    <div className="body">
                      <div className="name">{s.name}<span className="years">// {s.years}</span></div>
                      <div className="skill-bar">
                        <div className="skill-bar-fill" style={{ width: seen ? `${s.lvl}%` : '0%', transitionDelay: `${(gi * 4 + i) * 60}ms` }} />
                      </div>
                    </div>
                    <span className="lvl">{s.lvl}%</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
